module.exports = __webpack_public_path__ + "static/media/panthera-biopartners.8e7990e7.png";